import React  from 'react';
import { Skeleton, Stack } from "@mui/material";

export default function AutocompleteSkeleton() {
    return (
        <Stack spacing={1}>
            <Skeleton animation="wave" variant="text" width={'50%'} />
            <Skeleton animation="wave" variant="rectangular" height={35} />
        </Stack>
    );
}
